/**
 *
 * Retrieves the data for a fragment of an article
 *
 * - If an article id is passed in then that will be used to look up the relevant article.
 * - Otherwise it will return the article in the surrounding ArticleFragmentContext otherwise if that isn't set the ArticleContext will be tried.
 *
 * > **💡 NOTE**: If no matching article fragment can be found undefined is returned
 *
 * <div style="display:none">⏳ TODO confirm this is a good description</div>
 *
 *  @module
 */
import { useContext } from 'react';
import { ArticleFullContext, ArticleFragmentContext } from '../contexts';
import { useSelector } from '../actions/types';
import { categoryTree } from '../selectors';
import { usePageInfo } from '../hooks/usePageInfo';
import { throwIfDevelop } from '../utils';
/**
 *
 * # useArticleFragment
 *
 * Example usage:
 *
 * ```javascript
 * import { useArticleFragment } from "@elevio/kb-kit/lib/hooks";
 *
 * export const MyComponent = ({ articleId, usePageArticle }) => {
 *   const article = useArticleFragment({ articleId, usePageArticle });
 *   console.log(categoryId); // string
 *   console.log(path); // string
 *   console.log(lastPublishedAtLocal); // string
 *   console.log(lastPublishedAgo); // string
 *   console.log(id); // string
 *   console.log(title); // string
 *   console.log(lastPublishedAt); // long (UNIX epoch milliseconds)
 *   console.log(slug); // string
 *   console.log(summary); // string | undefined
 *
 *   return (
 *     ...
 *   );
 * };
 * ```
 */
export function useArticleFragment({ articleId, usePageArticle, } = {}) {
    var _a, _b;
    const fragmentId = useContext(ArticleFragmentContext);
    const articleFull = useContext(ArticleFullContext);
    const pageInfo = usePageInfo();
    const articlePageId = (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.pageType) === 'article' ? pageInfo.articleId : undefined;
    let idOfFragment;
    // If we are looking up the page category...
    if (usePageArticle) {
        if (!articlePageId) {
            throwIfDevelop(`trying to use category from page but not on a category page: ${JSON.stringify(pageInfo)}`);
        }
        idOfFragment = articlePageId;
    }
    else {
        idOfFragment = (_b = (_a = articleId !== null && articleId !== void 0 ? articleId : fragmentId) !== null && _a !== void 0 ? _a : articleFull === null || articleFull === void 0 ? void 0 : articleFull.id) !== null && _b !== void 0 ? _b : articlePageId;
    }
    const fragment = useSelector((state) => {
        if (!idOfFragment)
            return null;
        return categoryTree.articleFragment(state, idOfFragment);
    });
    return fragment;
}
//# sourceMappingURL=useArticleFragment.js.map